export const buttonSize = Object.freeze({
  small: {
    class: 'btn-small'
  },
  middle: {
    class: 'btn-middle'
  },
  large: {
    class: 'btn-large'
  },
  default: {
    class: 'btn-middle'
  },
  smallSquare: {
    class: 'btn-small-square'
  },
  middleSquare: {
    class: 'btn-middle-square'
  },
  largeSquare: {
    class: 'btn-large-square'
  },
});
